import { IUserLegalInfoFormFields } from '../UserLegalInfoFields.types';

type IUserLegalInfoFormFieldsKey = keyof IUserLegalInfoFormFields;

const RequiredFieldForTenants: {
  label: string;
  value: IUserLegalInfoFormFieldsKey;
}[] = [
  { label: 'form:companyName', value: 'company_name' },
  { label: 'form:vatNumber', value: 'vat_number' },
  { label: 'form:city', value: 'company_city' },
  { label: 'form:country', value: 'company_country' },
  { label: 'form:province', value: 'company_province' },
  { label: 'form:residenceAddress', value: 'company_address' },
  { label: 'form:postalCode', value: 'company_postcode' },
];

export const filterMissingUserLegalInformation = ({
  values,
}: {
  values: IUserLegalInfoFormFields;
}) => {
  const emptyFields = RequiredFieldForTenants.filter(
    field => !values[field.value],
  ).map(field => field.label);

  const label = 'form:legalPerson';

  return {
    label,
    fields: emptyFields,
  };
};
